module.exports = __webpack_public_path__ + "static/media/colicoli4.1a498714.webp";